import React from 'react';

import {
  List,
  Datagrid,
  TextField,
  ArrayField,
  SingleFieldList,
  usePermissions,
  ArrayInput,
} from 'react-admin';

import { Card } from '@mui/material';

import { boldDataGridStyle } from '../../constants/style/datagridStyles';

import NoResults from '../layout/NoResults';
import Pagination from '../layout/Pagination';
import LinkField from '../layout/LinkField';

import ColoredScoreField from '../../customFields/ColoredScoreField';
import { NationalIdentifierSingleField } from '../../customFields/NationalIdentifier';
import ChipStringField from '../../customFields/ChipStringField';
import { ReferenceManyDisplayField } from '../../customFields/EditReferenceManyField';
import SearchField from '../../customFields/SearchField';
import actions, { Actions } from '../../constants/actions';
import hasAccess from '../../utilities/hasAccess';
import GroupFilter from '../utils/GroupFilter';

export const IndividualListBody = ({ children }: {children?: React.ReactElement}) => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Datagrid bulkActionButtons={false} sx={boldDataGridStyle} empty={<NoResults variant="h6" />}>
      {hasAccess(permissions, actions.INDIVIDUAL_GET) ? (
        <LinkField sortable={false} source="id" label="ID" />
      ) : (
        <TextField sortable={false} source="id" label="ID" />
      )}
      <ArrayField sortable={false} source="customIds" label="Custom IDs">
        <SingleFieldList linkType={false}>
          <ChipStringField />
        </SingleFieldList>
      </ArrayField>
      {hasAccess(permissions, actions.GROUP_LIST) && (
        <ReferenceManyDisplayField
          sortable
          label="Groups"
          reference="groups"
          source="groups"
        />
      )}
      <NationalIdentifierSingleField label="National identifier" underline={false} />
      <TextField sortable={false} source="firstName" />
      <TextField sortable={false} source="lastName" />
      <ColoredScoreField source="riskScore" />
      {children}
    </Datagrid>
  );
};

export const getIndividualFilters = ({
  hideSearch = false,
}) => [
  ...(hideSearch ? [] : [<SearchField source="search" label="Search" alwaysOn />]),
  <ArrayInput source="groups" label="Groups">
    <GroupFilter />
  </ArrayInput>,
];

const IndividualFilters = getIndividualFilters({});

const IndividualList = () => (
  <List
    resource="individuals"
    filters={IndividualFilters}
    sort={{ field: 'createdAt', order: 'DESC' }}
    empty={false}
    pagination={<Pagination disableEmptyText />}
    exporter={false}
    perPage={50}
  >
    <Card sx={{ margin: 0 }} variant="outlined">
      <IndividualListBody />
    </Card>
  </List>
);

export default IndividualList;
